<template>
  <div id="transferOrder" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">调单类型：</div>
          <div class="content">
            <el-select v-model="form.transferOrderType" placeholder="请选择" @change="searchBtn">
              <el-option v-for="item in transferOrderTypeList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">活动编号：</div>
          <div class="content">
            <el-input v-model="form.activityCode" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">待调单人：</div>
          <div class="content">
            <el-select
              clearable
              v-model="form.assigneeId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="assigneeLoading"
            >
              <el-option v-for="item in assigneeList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <commonTable
      ref="transferOrderTable"
      edit-mode="cell"
      @editActivedEvent="editActivedEvent"
      @editClosed="editClosed"
      @handleTableList="getTableList"
    />
    <approvalDetailsDialog
      :expenses-code="rowData.expenseBelongId"
      :if-report="rowData.ifReport"
      :approval-dialog-visible="approvalDialogVisible"
      @jumpHandle="jumpHandle"
      @dialogCloseHandle="detailsDialogCloseHandle"
    />
    <updateTimeDialog
      :row-data="rowData"
      :time-dialog-visible="timeDialogVisible"
      @dialogCloseHandle="timeDialogCloseHandle"
      @editTimeSubHandle="editTimeSubHandle"
    />
  </div>
</template>

<script>
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { arrayQuery, isNotEmpty } from '@/utils/utils';
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { transferOrderApi, approvalManagementApi } from './service';
import approvalDetailsDialog from './component/transferOrder/approvalDetailsDialog';
import updateTimeDialog from './component/transferOrder/updateTimeDialog';

export default {
  data () {
    return {
      transferOrderTypeList: [
        {
          label: '调整活动审批人',
          value: 'processNode'
        },
        {
          label: '调整活动起止日期',
          value: 'activityDate'
        }
      ],
      assigneeList: [],
      assigneeLoading: false,
      tableData: [],
      form: {
        transferOrderType: 'processNode',
        activityCode: ''
      },
      applyUserList: [],
      saleLoading: false,
      approvalDialogVisible: false,
      timeDialogVisible: false,
      rowData: {},
      financialSystemList: [],
      isLang: true
    };
  },
  components: {
    commonTable,
    approvalDetailsDialog,
    updateTimeDialog
  },
  methods: {
    remoteMethod (query) {
      if (query && query.indexOf(' ') === -1) {
        this.assigneeLoading = true;
        transferOrderApi.getAllSalesmanList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.assigneeList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            } else {
              this.assigneeList = [];
            }
          }
          this.assigneeLoading = false;
        });
      }
    },
    editTimeSubHandle (data) {
      transferOrderApi.updateTime(data).then(res => {
        if (res.status === '200') {
          this.timeDialogVisible = false;
          this.$message.success('修改成功');
          this.searchBtn();
        }
      });
    },
    timeEditHandle (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.timeDialogVisible = true;
    },
    timeDialogCloseHandle () {
      this.timeDialogVisible = false;
    },
    jumpHandle () {
      this.approvalDialogVisible = false;
      this.searchBtn();
    },
    detailsDialogCloseHandle () {
      this.approvalDialogVisible = false;
    },
    approvalDetails (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.approvalDialogVisible = true;
    },
    editClosed ({ row }) {
      let params = {};
      let temporary = JSON.parse(JSON.stringify(this.rowData));
      if (temporary.applyUserName !== row.applyUserName) {
        params = {
          activityCode: row.activityCode,
          applyUserId: row.applyUserId,
          applyUserName: row.applyUserName,
          applyUserDeptCode: row.applyUserDeptCode,
          applyUserDeptName: row.applyUserDeptName
        };
      } else if (temporary.expApplyUserName !== row.expApplyUserName) {
        params = {
          expenseBelongId: row.expenseBelongId,
          applyUserId: row.expApplyUserId,
          applyUserName: row.expApplyUserName,
          applyUserDeptCode: row.expApplyUserDeptCode,
          applyUserDeptName: row.expApplyUserDeptName
        };
      } else if (temporary.financialSystemName !== row.financialSystemName) {
        // 判断当前是否中文
        const type = this.isLang ? 'shortName' : 'englishShortName';
        params = {
          expenseBelongId: row.expenseBelongId,
          applyUserId: row.expApplyUserId,
          applyUserName: row.expApplyUserName,
          applyUserDeptCode: row.expApplyUserDeptCode,
          applyUserDeptName: row.expApplyUserDeptName,
          financialSystemCode: this.financialSystemList.find(item => item[type] === row.financialSystemName).code,
          financialSystemName: row.financialSystemName
        };
      } else if (temporary.salerName !== row.salerName) {
        params = {
          activityCode: row.activityCode,
          salerId: row.salerId,
          salerName: row.salerName,
          salerDeptCode: row.salerDeptCode,
          salerDeptName: row.salerDeptName
        };
      } else {
        return;
      }
      this.$confirm('确定移交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.transferOrderTable.loading = true;
        transferOrderApi.approveUserTransfer(params).then(res => {
          if (res.status === '200') {
            this.$message.success('移交成功');
            this.searchBtn();
          } else {
            this.$refs.transferOrderTable.reviseRow(temporary);
          }
          this.$refs.transferOrderTable.loading = false;
        });
      }).catch(() => {
        this.$refs.transferOrderTable.reviseRow(temporary);
      });
    },
    editActivedEvent ({ row }) {
      this.rowData = JSON.parse(JSON.stringify(row));
    },
    reset () {
      this.form = {
        transferOrderType: 'processNode',
        activityCode: ''
      };
      this.searchBtn();
    },
    detailsJump (row) {
      let path = '/activityDetails';
      if (row.reportType) {
        path = row.reportType === '1' ? '/regionReportDetails' : '/industryReportDetails';
      } else {
        path = row.submitType === 'report_submit' ? '/reportDetails' : '/activityDetails';
      }
      this.$router.push({
        path,
        query: {
          activityCode: row.activityCode,
          metaActive: '/transferOrder'
        }
      });
    },
    searchBtn () {
      this.$refs.transferOrderTable.pageData.pageNum = 1;
      this.loadTable();
      this.getTableData();
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('活动编号')
          ._width('10%')
          ._data('activityCode')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => { this.detailsJump(row); }}>{ row.activityCode }</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('活动名称')
          ._width('10%')
          ._data('activityName')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动申请人')
          ._width('10%')
          ._data('applyUserName')
          ._editType('editSelect')
          ._editData({
            options: this.applyUserList,
            optionProps: {
              label: 'userName',
              value: 'userName',
              filterable: true,
              remote: true,
              reserveKeyword: true,
              loading: this.saleLoading,
              remoteMethod: (data) => {
                if (data !== '') {
                  this.saleLoading = true;
                  approvalManagementApi.getApprovedList(data).then(res => {
                    if (res.status === '200') {
                      this.applyUserList = res.data ? res.data : [];
                      this.saleLoading = false;
                      this.loadTable();
                    }
                  });
                } else {
                  this.applyUserList = [];
                  this.loadTable();
                }
              }
            },
            events: {
              change: ({ row }) => {
                let userData = arrayQuery(row.applyUserName, this.applyUserList, 'userName');
                row.applyUserId = userData.userId;
                row.applyUserDeptCode = userData.deptCode;
                row.applyUserDeptName = userData.deptName;
              }
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('费用申请人')
          ._width('10%')
          ._data('expApplyUserName')
          ._editType('editSelect')
          ._editData({
            options: this.applyUserList,
            optionProps: {
              label: 'userName',
              value: 'userName',
              filterable: true,
              remote: true,
              reserveKeyword: true,
              loading: this.saleLoading,
              remoteMethod: (data) => {
                if (data !== '') {
                  this.saleLoading = true;
                  approvalManagementApi.getApprovedList(data).then(res => {
                    if (res.status === '200') {
                      this.applyUserList = res.data ? res.data : [];
                      this.saleLoading = false;
                      this.loadTable();
                    }
                  });
                } else {
                  this.applyUserList = [];
                  this.loadTable();
                }
              }
            },
            events: {
              change: ({ row }) => {
                let userData = arrayQuery(row.expApplyUserName, this.applyUserList, 'userName');
                row.expApplyUserId = userData.userId;
                row.expApplyUserDeptCode = userData.deptCode;
                row.expApplyUserDeptName = userData.deptName;
              }
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('对应销售')
          ._width('8%')
          ._data('salerName')
          ._editType('editSelect')
          ._editData({
            options: this.applyUserList,
            optionProps: {
              label: 'userName',
              value: 'userName',
              filterable: true,
              remote: true,
              reserveKeyword: true,
              loading: this.saleLoading,
              remoteMethod: (data) => {
                if (data !== '') {
                  this.saleLoading = true;
                  approvalManagementApi.getApprovedList(data).then(res => {
                    if (res.status === '200') {
                      this.applyUserList = res.data ? res.data : [];
                      this.saleLoading = false;
                      this.loadTable();
                    }
                  });
                } else {
                  this.applyUserList = [];
                  this.loadTable();
                }
              }
            },
            events: {
              change: ({ row }) => {
                let userData = arrayQuery(row.salerName, this.applyUserList, 'userName');
                row.salerId = userData.userId;
                row.salerDeptCode = userData.deptCode;
                row.salerDeptName = userData.deptName;
              }
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('财务体系')
          ._width('8%')
          ._data('financialSystemName')
          ._editType('editSelect')
          ._editData({
            options: this.financialSystemList,
            optionProps: {
              label: this.isLang ? 'shortName' : 'englishShortName',
              value: this.isLang ? 'shortName' : 'englishShortName',
              filterable: true,
              remote: true
            },
            events: {
              focus: ({ row }) => {
                if (row.financialSystemName) {
                  newApplicationFormApi.getFinancialList(row.salerId).then(res => {
                    if (res.status === '200') {
                      if (isNotEmpty(res.data)) {
                        this.isLang = res.data.findIndex(item => item.shortName === row.financialSystemName) !== -1;
                        this.financialSystemList = res.data;
                        this.loadTable();
                      }
                    }
                  });
                }
              }
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门')
          ._width('10%')
          ._data('salerDeptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('预计举办日期')
          ._width('8%')
          ._data('expectStartDate')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('预计结束日期')
          ._width('8%')
          ._data('expectEndDate')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row.expectEndDate.replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('审批流程')
          ._width('6%')
          ._data('approveStatus')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let statusText = '';
              if (row.approvalStat === '1') {
                statusText = '待审批';
              } else {
                statusText = '已审批';
              }
              return (
                <div>
                  <el-button disabled={ this.form.transferOrderType === 'activityDate' } type="text" onClick={() => {
                    this.approvalDetails(row);
                  }}>{statusText}</el-button>
                </div>
              );
            }
          })
      );
      if (this.form.transferOrderType === 'activityDate') {
        tableRow.push(
          new TableColumns()
            ._title('操作')
            ._width('10%')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div>
                    <el-button type="text" onClick={() => {
                      this.timeEditHandle(row);
                    }}>日期修改
                    </el-button>
                  </div>
                );
              }
            })
        );
      }
      let column = tableRow._cols();
      this.$refs.transferOrderTable.setColumn(column);
    },
    getTableData () {
      this.$refs.transferOrderTable.loadTable({ url: '/activity/activity_list', listKey: 'list', params: this.form });
    },
    getTableList () {
      let { dataList } = this.$refs.transferOrderTable.tableData;
      dataList.forEach(item => {
        item.financialSystemName = item.financialSystemName ? item.financialSystemName : '-';
      });
      this.loadTable();
    },
    initFn () {
      this.getTableData();
    }
  },
  mounted () {
    this.initFn();
  }
};
</script>

<style scoped>

</style>
